import { render, staticRenderFns } from "./SignInPage.vue?vue&type=template&id=1ba47d0c&scoped=true&"
import script from "./SignInPage.vue?vue&type=script&lang=js&"
export * from "./SignInPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba47d0c",
  null
  
)

export default component.exports